import type { FileUploadButtonProps } from '@lotta/self-service/lottery-fe/ui-common';
import { FileUploadButton } from '@lotta/self-service/lottery-fe/ui-common';
import { useCallback } from 'react';
import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import readXlsxFile from 'read-excel-file';
import { sheetToParticipants } from './utils/sheet-to-participants';

type UploadManualParticipantsButtonProps = {
  // Participants is a list of partyUids
  handleParticipants: (
    participants: Array<{
      partyUid: string;
      entryDate: string;
    }>
  ) => void;
  handleError: (error: FieldError) => void;
  small?: FileUploadButtonProps['small'];
  className?: FileUploadButtonProps['className'];
};

export const UploadManualParticipantsButton: React.FC<UploadManualParticipantsButtonProps> = ({
  handleParticipants,
  handleError,
  ...buttonProps
}) => {
  const { t } = useTranslation();

  const handleFileUpload = useCallback(
    async (file: File) => {
      try {
        const sheet = await readXlsxFile(file);
        const participants = sheetToParticipants(sheet);
        handleParticipants(participants);
      } catch (err) {
        handleError({
          type: 'custom',
          message: 'general-something-went-wrong',
        });
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
    [handleError, handleParticipants]
  );

  return (
    <FileUploadButton
      type="secondary"
      accept=".xlsx"
      label={t('lottery-details-manage-manual-participants-upload-xlsx-button')}
      onUploadFile={handleFileUpload}
      {...buttonProps}
    />
  );
};
